module.exports = {
          srcSet: "/_next/static/images/img-voitures@2x-160-6474fd74aac53a9958e06d676feda91c.webp"+" 160w"+","+"/_next/static/images/img-voitures@2x-292-2813acdc3a77441a60d81e12e9c429a3.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-voitures@2x-160-6474fd74aac53a9958e06d676feda91c.webp",width: 160,height: 137},{path: "/_next/static/images/img-voitures@2x-292-2813acdc3a77441a60d81e12e9c429a3.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-voitures@2x-160-6474fd74aac53a9958e06d676feda91c.webp",
          toString:function(){return "/_next/static/images/img-voitures@2x-160-6474fd74aac53a9958e06d676feda91c.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }